module.exports = __webpack_public_path__ + "20250721160708/img/stu_report.7e8a0e7a.png";